const capitalizeFirstLetter = text => text?.[0]?.toUpperCase() + text?.slice(1) ?? '';
export default capitalizeFirstLetter;
